import { reactive } from 'vue'

export const sharedState = reactive({
  activeRaceEventId: null,
  activeRaceEventSlug: null,
  activeRaceId: null,
  requestedActiveRaceEventId: null,
  filteredRaceIds: {},
  loading: Object.create(null),
  loadingEntities: [],
  channelConnected: {},
  lpsMonitorState: 'unknown',

  raceEvent: {},
  race: {},
  participant: {},
  addon: {},
  addonVariant: {},
  lineItem: {},
})

let _eid = Math.round(Math.random() * 1000)
export function ephermeralId() {
  return 'NEW-' + _eid++;
}
